import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';

function MatchCard({ match, t }) {
  const player1Name = match.player1Name || '—';
  const player2Name = match.bye ? t('groups.tournament.bye') : (match.player2Name || '—');
  const player1Won = match.winnerId != null && match.winnerId === match.player1Id;
  const player2Won = match.winnerId != null && match.winnerId === match.player2Id;

  return (
    <Paper
      variant="outlined"
      sx={{
        p: 1,
        minWidth: 180,
        borderRadius: 2,
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 1 }}>
        <Typography variant="body2" fontWeight={player1Won ? 700 : 400} noWrap>
          {player1Name}
        </Typography>
        {match.player1Score != null && (
          <Typography variant="body2" fontWeight={player1Won ? 700 : 400} color={player1Won ? 'primary.main' : 'text.secondary'}>
            {match.player1Score}
          </Typography>
        )}
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 1 }}>
        <Typography variant="body2" fontWeight={player2Won ? 700 : 400} color={match.bye ? 'text.disabled' : 'text.primary'} noWrap>
          {player2Name}
        </Typography>
        {match.player2Score != null && (
          <Typography variant="body2" fontWeight={player2Won ? 700 : 400} color={player2Won ? 'primary.main' : 'text.secondary'}>
            {match.player2Score}
          </Typography>
        )}
      </Box>
    </Paper>
  );
}

export default function TournamentBracket({ tournament, t }) {
  if (!tournament || !Array.isArray(tournament.rounds) || tournament.rounds.length === 0) {
    return null;
  }

  return (
    <Box>
      {tournament.status === 'COMPLETED' && tournament.winnerName && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2, justifyContent: 'center' }}>
          <EmojiEventsIcon color="warning" />
          <Typography variant="subtitle1" fontWeight={700}>
            {t('groups.tournament.winner', { name: tournament.winnerName })}
          </Typography>
        </Box>
      )}
      <Box sx={{ display: 'flex', gap: 3, overflowX: 'auto', pb: 1 }}>
        {tournament.rounds.map((round) => (
          <Box key={round.roundNumber} sx={{ display: 'flex', flexDirection: 'column', gap: 2, minWidth: 190 }}>
            <Typography variant="caption" fontWeight={700} color="text.secondary" textAlign="center">
              {round.roundLabel}
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, justifyContent: 'space-around', flex: 1 }}>
              {round.matches.map((match) => (
                <MatchCard key={match.matchIndex} match={match} t={t} />
              ))}
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
